"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriorityFlag = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _styles = require("./styles");

var _noPriority = _interopRequireDefault(require("../../../assets/images/flags/noPriority.svg"));

var _highPriority = _interopRequireDefault(require("../../../assets/images/flags/highPriority.svg"));

var _mediumPriority = _interopRequireDefault(require("../../../assets/images/flags/mediumPriority.svg"));

var _lowPriority = _interopRequireDefault(require("../../../assets/images/flags/lowPriority.svg"));

var _jsxRuntime = require("react/jsx-runtime");

var PriorityFlag = function PriorityFlag(_ref) {
  var _PriorityFlags;

  var priority = _ref.priority;
  var PriorityFlags = (_PriorityFlags = {}, (0, _defineProperty2.default)(_PriorityFlags, "none", _noPriority.default), (0, _defineProperty2.default)(_PriorityFlags, "low", _lowPriority.default), (0, _defineProperty2.default)(_PriorityFlags, "medium", _mediumPriority.default), (0, _defineProperty2.default)(_PriorityFlags, "high", _highPriority.default), _PriorityFlags);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: PriorityFlags[priority],
      alt: priority
    })
  });
};

exports.PriorityFlag = PriorityFlag;